import React, { Component } from "react";
import { Row, Col, Button, Modal } from "react-bootstrap";
class DeleteSupportType extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }
  Submit = () => {
    let id = this.props.DeletesupportTypeItem && this.props.DeletesupportTypeItem.id;

    this.props.DeleteSupportType(id);
    this.props.closesupportTypeDelModel();
    this.props.resetPage();
  };
  render() {
    return (
      <div>
        <Modal
          show={this.props.showsupportTypeDelModel}
          animation={false}
          size="md"
          backdrop="static"
          onHide={this.props.closesupportTypeDelModel}
        >
          <Modal.Header
            style={{ fontSize: "35px", backgroundColor: "#f0f3f5" }}
          >
            <Modal.Title>
              <span style={{ fontSize: "20px" }}>Delete Support Type</span>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {" "}
            <div>
              <h6 style={{ textAlign: "center", marginTop: "20px" }}>
                <b>Are you sure you want to delete?</b>
              </h6>
            </div>
            <Row style={{ marginTop: "30px", marginBottom: "20px" }}>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Button
                  className="cmnDelCnclBtn"
                  variant="danger"
                  onClick={() => this.props.closesupportTypeDelModel()}
                >
                  CANCEL
                </Button>
              </Col>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Button
                  variant="success"
                  className="cmnDelOkBtn"
                  onClick={this.Submit}
                >
                  OK
                </Button>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default DeleteSupportType;
